import ApiService from './ApiService'

class UserService {
  inviteUser = async (apiToken, data) => {
    var url = '/api/user/invite'

    // var params = {
    //   fields: 'id,firstName,lastName,email,userName',
    //   limit: 1000
    // }

    var params = {}

    var options = {
      email: [data.email],
      role: data.role,
      organisation: data.organisation
    }

    try {
      var result = await ApiService.post(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  createUser = async (apiToken, options) => {
    var url = '/api/user'

    // var params = {
    //   fields: 'id,firstName,lastName,email,userName',
    //   limit: 1000
    // }

    var params = {}

    // var options = {
    //   data
    // }

    try {
      var result = await ApiService.post(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  getUser = async (apiToken, params, userId) => {
    var url = `/api/user/${userId}`

    try {
      var user = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return user
  }

  getUsers = async (apiToken, params) => {
    var url = '/api/user'

    // var params = {
    //   fields: 'id,firstName,lastName,email,userName,reference,ethnicity,gender,createdAt',
    //   limit: 1000
    // }

    // if (where) {
    //   params.where = where
    // }

    try {
      var users = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return users
  }

  updateUser = async (apiToken, data, type = 'user') => {
    const userId = data.id
    var url = `/api/user/${userId}`

    // var params = {
    //   fields: 'id,firstName,lastName,email,userName',
    //   limit: 1000
    // }

    var params = {
      type
    }

    var options = {
      data: data
    }
    // var options = {
    //   data: {
    //     email: data.email,
    //     firstName: data.firstName,
    //     lastName: data.lastName,
    //     reference: data.reference,
    //     // dob: data.dob,
    //     ethnicity: data.ethnicity,
    //     genedr: data.gender
    //   }
    // }

    try {
      var result = await ApiService.put(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  deleteUser = async (apiToken, data) => {
    const userId = data.id
    var url = `/api/user/${userId}`

    var params = {}

    var options = {}
    try {
      var result = await ApiService.sendDelete(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  acceptInvite = async (inviteToken, data) => {

    var url = '/api/accept-invite'


    const body = {
      token: inviteToken,
      user: {
        firstName: data.firstname,
        lastName: data.lastname,
        password: data.password
      },
      acceptTerms: data.tandc,
      userType: data.type
    }

    try {
      var result = await ApiService.post(null, url, {}, body)
    } catch (err) {
      console.error(err)
    }
    return result
  }
}
export default new UserService()
